// extracted by mini-css-extract-plugin
module.exports = {"backButton":"AssessmentBackButton_backButton__veyTN"};